<template>
	<div class="select-amount">
		<v-subheader class="px-0">
			<label for="select-amount-input">Velg beløp</label>
		</v-subheader>

		<v-input id="select-amount-input" class="select-amount__input">
			<template #prepend>
				<v-btn color="primary" height="49" :min-width="$vuetify.breakpoint.xsOnly ? '49' : undefined" depressed @click="decAmountClick" :class="[$vuetify.breakpoint.xsOnly && 'px-0']">
					<v-icon>remove_circle</v-icon>
				</v-btn>
			</template>
			<v-text-field prefix="kr" v-model="amount" class="prime" placeholder=" " hint="Minimum kr 100" type="number" persistent-hint :rules="[rules.notDecimal, rules.notStartWithZero]" />
			<template #append>
				<v-btn color="primary" height="49" :min-width="$vuetify.breakpoint.xsOnly ? '49' : undefined" depressed @click="incAmountClick" :class="[$vuetify.breakpoint.xsOnly && 'px-0']">
					<v-icon>add_circle</v-icon>
				</v-btn>
			</template>
		</v-input>

		<v-row align="center" justify="start" class>
			<v-col class="py-0">
				<v-btn v-for="amount in predefinedAmounts" :key="amount" class="mr-1 mb-1 px-3" outlined @click="setAmountByValue(amount)">
					<small>{{ amount }}</small>
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
const stepValue = 50;
const minGiftcardAmount = 100;
const maxGiftcardAmount = 20000;

export default {
	name: 'buy-giftcard-select-amount',
	components: {},
	props: {
		value: null
	},

	data() {
		return {
			predefinedAmounts: [250, 500, 750, 1000, 1500, 2000],
			rules: {
				notDecimal: value => (value && value.toString().indexOf('.')) == -1 || 'Vi støtter ikke gavekort med desimaltall',
				notStartWithZero: value => (value && !/^0/.test(value.toString())) || 'Beløpet kan ikke starte med tallet 0'
			}
		};
	},
	computed: {
		amount: {
			get() {
				return this.value;
			},

			set(value) {
				this.$emit('input', value);
			}
		}
	},
	methods: {
		// Validation of giftcard amount
		setAmountByValue(newAmount) {
			// The first step we don't allow 50 as stepper.
			newAmount = +newAmount;
			if (newAmount == stepValue) {
				this.amount = minGiftcardAmount;
			}

			// Handle value set from both url parameter and increased and decreased by the buttons
			if (this.isAmountValid(newAmount)) {
				this.amount = newAmount;
			} else if (newAmount >= maxGiftcardAmount) {
				this.amount = maxGiftcardAmount;
			} else if (newAmount <= maxGiftcardAmount) {
				this.amount = 100;
			}
		},
		isAmountValid(newAmount) {
			return newAmount >= minGiftcardAmount && newAmount <= maxGiftcardAmount && newAmount > 0;
		},
		decAmountClick() {
			let newValue = parseInt(this.amount) - stepValue;
			this.setAmountByValue(newValue);
		},
		incAmountClick() {
			let newValue = parseInt(this.amount) + stepValue;
			this.setAmountByValue(newValue);
		}
	}
};
</script>

<style lang="scss" scoped>
.select-amount {
	&__input {
		position: relative;

		.v-input {
			padding-top: unset;
		}
	}
}
</style>
